import React from 'react';
import Remark from './remarks';

class Viewall extends React.Component {

  state = {

  }

  render() {
    let i = 0;
    return (

        <table width='100%' id="table">
          <tr>
            <th id="tableheader" style={{width: '5%'}}><center>Sino</center></th>
            <th id="tableheader" style={{width: '5%'}}><center>Ticket ID</center></th>
            <th id="tableheader" style={{width: '20%'}}><center>Title</center></th>
            <th id="tableheader" style={{width: '15%'}}><center>Executive</center></th>
            <th id="tableheader" style={{width: '15%'}}><center>Created By</center></th>
            <th id="tableheader" style={{width: '13%'}}><center>Created On</center></th>
            <th id="tableheader" style={{width: '7%'}}><center>Status</center></th>
            <th id="tableheader" style={{width: '7%'}}><center>Remark</center></th>
          </tr>
          { this.props.data.map((x) => {
              if (this.props.status1 == 'All') {
                i++;
                return (
                  <tbody>
                    <tr>
                      <td><center>{i}</center></td>
                      <td><center>{x.id}</center></td>
                      <td><center>{x.title}</center></td>
                      <td><center>{x.assigned_to+"->"+x.executive_name}</center></td>
                      <td><center>{x.created_by+'->'+x.creator_name}</center></td>
                      <td><center>{x.timestamp}</center></td>
                      <td><center>{x.status}</center></td>
                      <td><center><Remark remark={x.content} /></center></td>
                    </tr>
                  </tbody>
                )
              }
              else {
                if (this.props.status1 == x.status) {
                  i++;
                  return (
                    <tbody>
                      <tr>
                        <td><center>{i}</center></td>
                        <td><center>{x.id}</center></td>
                        <td><center>{x.title}</center></td>
                        <td><center>{x.assigned_to+"->"+x.executive_name}</center></td>
                        <td><center>{x.created_by+'->'+x.creator_name}</center></td>
                        <td><center>{x.timestamp}</center></td>
                        <td><center>{x.status}</center></td>
                        <td><center><Remark remark={x.content} /></center></td>
                      </tr>
                    </tbody>
                  )
                }
              }
            })
          }
        </table>
    );
  }
}

export default Viewall;
